import React, { useState, useEffect } from 'react';
import { GiConsoleController } from 'react-icons/gi';
import styled from 'styled-components';

const MerchantReferral = () => {
  const [phoneNumber, setPhoneNumber] = useState('');
  const [user, setUser] = useState(null);
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    try {
      const googleLogin = localStorage.getItem('googleLogin');
      const isGoogle = googleLogin !== 'false';
      const userData = localStorage.getItem(isGoogle ? 'merchantDashboardLogin' : 'merchantLogin');

      if (userData) {
        const parsed = JSON.parse(userData);
        setUser(parsed);
        setData(parsed);
      }
    } catch (error) {
      console.error('Error reading login info:', error);
    } finally {
      setLoading(false);
    }
  }, []);

  const handleRefer = () => {
    const trimmed = phoneNumber.trim();

    if (!/^[6-9]\d{9}$/.test(trimmed)) {
      alert('Please enter a valid 10-digit Indian mobile number.');
      return;
    }

    if (!user) {
      alert('User data not loaded yet. Please try again.');
      return;
    }

    const fullNumber = `91${trimmed}`;
    const message = encodeURIComponent(
      `Hey! Check out this amazing platform https://bakpoket.com/MerchantSignup/${data?.referralCode}. Join using my referral!`
    );
    window.open(`https://wa.me/${fullNumber}?text=${message}`, '_blank');
  };

  // console.log(data?.referralCode)
  return (
    <Container>
      <InnerBox>
        <h5>Refer a Merchant via WhatsApp</h5>
        <small className='text-center'>
          The more merchants get registered through your WhatsApp, the more reviews your store gets from Fashque, driving more customers to your e-store.
        </small>
        <Input
          type="tel"
          placeholder="Enter 10-digit mobile number"
          value={phoneNumber}
          onChange={(e) => setPhoneNumber(e.target.value.replace(/\D/g, '').slice(-10))}
        />
        <Button onClick={handleRefer} disabled={!user || loading}>
          {loading ? 'Loading...' : 'Send Referral'}
        </Button>
      </InnerBox>
    </Container>
  );
};

export default MerchantReferral;

// Styled Components
const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 20px;
`;

const InnerBox = styled.div`
  width: 100%;
  max-width: 400px;
`;

const Input = styled.input`
  width: 100%;
  padding: 12px;
  font-size: 16px;
  margin: 12px 0;
  border: 1px solid #ccc;
  border-radius: 8px;

  @media(max-width:576px){
    padding: 7px;
    font-size: 11px;
    margin: 6px 0;
  }
`;

const Button = styled.button`
  width: 100%;
  padding: 12px 20px;
  font-size: 16px;
  background-color: #25d366;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;

  &:hover {
    background-color: #1ebd5a;
  }

  &:disabled {
    background-color: #a6a6a6;
    cursor: not-allowed;
  }

  @media(max-width:576px){
    padding: 7px 10px;
    font-size: 10px;
  }
`;
